var items = {
  "block.minecraft.air": "air",
  "block.minecraft.stone": "stone",
  "block.minecraft.granite": "red grainstone",
  "block.minecraft.polished_granite": "red grained marble",
  "block.minecraft.diorite": "limestone",
  "block.minecraft.polished_diorite": "white marble",
  "block.minecraft.andesite": "grainstone",
  "block.minecraft.polished_andesite": "grained marble",
  "block.minecraft.grass_block": "block of grassy dirt",
  "block.minecraft.dirt": "dirt",
  "block.minecraft.coarse_dirt": "coarse dirt",
  "block.minecraft.podzol": "ashy dirt",
  "block.minecraft.crimson_nylium": "crimson nylium",
  "block.minecraft.warped_nylium": "warp'd nylium",
  "block.minecraft.cobblestone": "cobble",
  "block.minecraft.oak_planks": "oaken timber",
  "block.minecraft.spruce_planks": "pine timber",
  "block.minecraft.birch_planks": "birchen timber",
  "block.minecraft.jungle_planks": "exotic timber",
  "block.minecraft.acacia_planks": "beechen timber",
  "block.minecraft.dark_oak_planks": "ebon timber",
  "block.minecraft.crimson_planks": "crimsonwood planks",
  "block.minecraft.warped_planks": "warpwood planks",
  "block.minecraft.oak_sapling": "oak sapling",
  "block.minecraft.spruce_sapling": "pine sapling",
  "block.minecraft.birch_sapling": "birch sapling",
  "block.minecraft.jungle_sapling": "exotic sapling",
  "block.minecraft.acacia_sapling": "beech sapling",
  "block.minecraft.dark_oak_sapling": "ebon sapling",
  "block.minecraft.bedrock": "touchstone",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "red sand",
  "block.minecraft.gravel": "gravel",
  "block.minecraft.gold_ore": "gold ore",
  "block.minecraft.iron_ore": "iron ore",
  "block.minecraft.coal_ore": "coal ore",
  "block.minecraft.nether_gold_ore": "nether gold ore",
  "block.minecraft.oak_log": "oaken log",
  "block.minecraft.spruce_log": "pine log",
  "block.minecraft.birch_log": "birchen log",
  "block.minecraft.jungle_log": "exotic log",
  "block.minecraft.acacia_log": "beechen log",
  "block.minecraft.dark_oak_log": "ebon log",
  "block.minecraft.crimson_stem": "crimson stem",
  "block.minecraft.warped_stem": "warp'd stem",
  "block.minecraft.stripped_oak_log": "hulled oak log",
  "block.minecraft.stripped_spruce_log": "hulled pine log",
  "block.minecraft.stripped_birch_log": "hulled birch log",
  "block.minecraft.stripped_jungle_log": "hulled exotic log",
  "block.minecraft.stripped_acacia_log": "hulled beech log",
  "block.minecraft.stripped_dark_oak_log": "hulled ebony log",
  "block.minecraft.stripped_crimson_stem": "bare crimson stem",
  "block.minecraft.stripped_warped_stem": "bare warp'd stem",
  "block.minecraft.stripped_oak_wood": "hulled oaken wood",
  "block.minecraft.stripped_spruce_wood": "hulled pine wood",
  "block.minecraft.stripped_birch_wood": "hulled birchen wood",
  "block.minecraft.stripped_jungle_wood": "hulled exotic wood",
  "block.minecraft.stripped_acacia_wood": "hulled beechen wood",
  "block.minecraft.stripped_dark_oak_wood": "hulled ebon wood",
  "block.minecraft.stripped_crimson_hyphae": "debarked crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "debarked warped hyphae",
  "block.minecraft.oak_wood": "oaken log",
  "block.minecraft.spruce_wood": "pine log",
  "block.minecraft.birch_wood": "birchen log",
  "block.minecraft.jungle_wood": "exotic log",
  "block.minecraft.acacia_wood": "beechen log",
  "block.minecraft.dark_oak_wood": "ebony log",
  "block.minecraft.crimson_hyphae": "crimson hyphæ",
  "block.minecraft.warped_hyphae": "warp'd hyphæ",
  "block.minecraft.oak_leaves": "oak leaves",
  "block.minecraft.spruce_leaves": "pine needles",
  "block.minecraft.birch_leaves": "birch leaves",
  "block.minecraft.jungle_leaves": "exotic leaves",
  "block.minecraft.acacia_leaves": "beech leaves",
  "block.minecraft.dark_oak_leaves": "ebon leaves",
  "block.minecraft.sponge": "sponge",
  "block.minecraft.wet_sponge": "wet sponge",
  "block.minecraft.glass": "glass",
  "block.minecraft.lapis_ore": "lapis ore",
  "block.minecraft.lapis_block": "block of lapis",
  "block.minecraft.dispenser": "dispenser",
  "block.minecraft.sandstone": "sandstone",
  "block.minecraft.chiseled_sandstone": "graven sandstone",
  "block.minecraft.cut_sandstone": "cut sandstone",
  "block.minecraft.note_block": "note block",
  "block.minecraft.powered_rail": "sparkling iron-rut",
  "block.minecraft.detector_rail": "sensing iron-rut",
  "block.minecraft.sticky_piston": "gluey extruder",
  "block.minecraft.cobweb": "cobweb",
  "block.minecraft.grass": "grass",
  "block.minecraft.fern": "fern",
  "block.minecraft.dead_bush": "dead shrub",
  "block.minecraft.seagrass": "sargasso",
  "block.minecraft.sea_pickle": "sea cucumber",
  "block.minecraft.piston": "extender",
  "block.minecraft.white_wool": "white wool",
  "block.minecraft.orange_wool": "tawny wool",
  "block.minecraft.magenta_wool": "mulberry wool",
  "block.minecraft.light_blue_wool": "whey wool",
  "block.minecraft.yellow_wool": "yellow wool",
  "block.minecraft.lime_wool": "lincoln wool",
  "block.minecraft.pink_wool": "carnation wool",
  "block.minecraft.gray_wool": "grey wool",
  "block.minecraft.light_gray_wool": "pale grey wool",
  "block.minecraft.cyan_wool": "turquoise wool",
  "block.minecraft.purple_wool": "purple wool",
  "block.minecraft.blue_wool": "blue wool",
  "block.minecraft.brown_wool": "brown wool",
  "block.minecraft.green_wool": "green wool",
  "block.minecraft.red_wool": "red wool",
  "block.minecraft.black_wool": "black wool",
  "block.minecraft.dandelion": "daffodil",
  "block.minecraft.poppy": "primrose",
  "block.minecraft.blue_orchid": "violets",
  "block.minecraft.allium": "saffron",
  "block.minecraft.azure_bluet": "harebell",
  "block.minecraft.red_tulip": "crimson carnation",
  "block.minecraft.orange_tulip": "tawny carnation",
  "block.minecraft.white_tulip": "white carnation",
  "block.minecraft.pink_tulip": "carnation",
  "block.minecraft.oxeye_daisy": "daisy",
  "block.minecraft.cornflower": "pansy",
  "block.minecraft.lily_of_the_valley": "lily of the valley",
  "block.minecraft.wither_rose": "wither'd rose",
  "block.minecraft.brown_mushroom": "brown mushroom",
  "block.minecraft.red_mushroom": "red mushroom",
  "block.minecraft.crimson_fungus": "crimson mushrump",
  "block.minecraft.warped_fungus": "warped mushrump",
  "block.minecraft.crimson_roots": "crimson rootes",
  "block.minecraft.warped_roots": "warp'd rootes",
  "block.minecraft.nether_sprouts": "nether sprouts",
  "block.minecraft.weeping_vines": "weeping tendrils",
  "block.minecraft.twisting_vines": "twisting tendrils",
  "block.minecraft.sugar_cane": "sugar cane",
  "block.minecraft.kelp": "seaweed",
  "block.minecraft.bamboo": "bamboo",
  "block.minecraft.gold_block": "block of gold",
  "block.minecraft.iron_block": "block of iron",
  "block.minecraft.oak_slab": "oaken slab",
  "block.minecraft.spruce_slab": "pine slab",
  "block.minecraft.birch_slab": "birchen slab",
  "block.minecraft.jungle_slab": "exotic slab",
  "block.minecraft.acacia_slab": "beechen slab",
  "block.minecraft.dark_oak_slab": "ebon slab",
  "block.minecraft.crimson_slab": "crimsonwood slab",
  "block.minecraft.warped_slab": "warpwood slab",
  "block.minecraft.stone_slab": "stone slab",
  "block.minecraft.smooth_stone_slab": "smooth stone slab",
  "block.minecraft.sandstone_slab": "sandstone slab",
  "block.minecraft.cut_sandstone_slab": "cut sandstone slab",
  "block.minecraft.petrified_oak_slab": "slab o' petrified oak",
  "block.minecraft.cobblestone_slab": "cobble slab",
  "block.minecraft.brick_slab": "brick slab",
  "block.minecraft.stone_brick_slab": "stone brick slab",
  "block.minecraft.nether_brick_slab": "nether brick slab",
  "block.minecraft.quartz_slab": "quarz slab",
  "block.minecraft.red_sandstone_slab": "red sandstone slab",
  "block.minecraft.cut_red_sandstone_slab": "cut red sandstone slab",
  "block.minecraft.purpur_slab": "purpur slab",
  "block.minecraft.prismarine_slab": "prismarine slab",
  "block.minecraft.prismarine_brick_slab": "prismarine brick slab",
  "block.minecraft.dark_prismarine_slab": "dark prismarine slab",
  "block.minecraft.smooth_quartz": "block of smooth quarz",
  "block.minecraft.smooth_red_sandstone": "smooth red sandstone",
  "block.minecraft.smooth_sandstone": "smooth sandstone",
  "block.minecraft.smooth_stone": "smooth stone",
  "block.minecraft.bricks": "bricks",
  "block.minecraft.tnt": "gunpowder cask",
  "block.minecraft.bookshelf": "bookshelf",
  "block.minecraft.mossy_cobblestone": "moss'd cobble",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "torch",
  "block.minecraft.end_rod": "end rod",
  "block.minecraft.chorus_plant": "chorus plant",
  "block.minecraft.chorus_flower": "chorus flower",
  "block.minecraft.purpur_block": "block of purpur",
  "block.minecraft.purpur_pillar": "purpur pillar",
  "block.minecraft.purpur_stairs": "purpur stairs",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "oaken stairs",
  "block.minecraft.chest": "chest",
  "block.minecraft.diamond_ore": "diamond ore",
  "block.minecraft.diamond_block": "block of diamond",
  "block.minecraft.crafting_table": "crafts table",
  "block.minecraft.farmland": "ploughed dirt",
  "block.minecraft.furnace": "furnace",
  "block.minecraft.ladder": "ladder",
  "block.minecraft.rail": "rut of iron",
  "block.minecraft.cobblestone_stairs": "cobble stairs",
  "block.minecraft.lever": "lever",
  "block.minecraft.stone_pressure_plate": "stone pressure plate",
  "block.minecraft.oak_pressure_plate": "oaken pressure plate",
  "block.minecraft.spruce_pressure_plate": "pine pressure plate",
  "block.minecraft.birch_pressure_plate": "birchen pressure plate",
  "block.minecraft.jungle_pressure_plate": "exotic pressure plate",
  "block.minecraft.acacia_pressure_plate": "beechen pressure plate",
  "block.minecraft.dark_oak_pressure_plate": "ebon pressure plate",
  "block.minecraft.crimson_pressure_plate": "crimsonwood pressure plate",
  "block.minecraft.warped_pressure_plate": "warpwood pressure plate",
  "block.minecraft.polished_blackstone_pressure_plate": "polish'd blackstone pressure plate",
  "block.minecraft.redstone_ore": "redstone ore",
  "block.minecraft.redstone_torch": "redstone torch",
  "block.minecraft.snow": "snow",
  "block.minecraft.ice": "ice",
  "block.minecraft.snow_block": "block of snow",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "clay",
  "block.minecraft.jukebox": "music box",
  "block.minecraft.oak_fence": "oaken hedge",
  "block.minecraft.spruce_fence": "pine hedge",
  "block.minecraft.birch_fence": "birchen hedge",
  "block.minecraft.jungle_fence": "exotic wood hedge",
  "block.minecraft.acacia_fence": "beechen hedge",
  "block.minecraft.dark_oak_fence": "ebony hedge",
  "block.minecraft.crimson_fence": "crimsonwood hedge",
  "block.minecraft.warped_fence": "warpwood hedge",
  "block.minecraft.pumpkin": "pumpion",
  "block.minecraft.carved_pumpkin": "carved pumpion",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "quicksand",
  "block.minecraft.soul_soil": "soil of soules",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polish'd basalt",
  "block.minecraft.soul_torch": "soule torch",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "oaken hatch",
  "block.minecraft.spruce_trapdoor": "pine hatch",
  "block.minecraft.birch_trapdoor": "birchen hatch",
  "block.minecraft.jungle_trapdoor": "exotic hatch",
  "block.minecraft.acacia_trapdoor": "beechen hatch",
  "block.minecraft.dark_oak_trapdoor": "ebon hatch",
  "block.minecraft.crimson_trapdoor": "crimsonwood hatch",
  "block.minecraft.warped_trapdoor": "warpwood hatch",
  "block.minecraft.infested_stone": "infested stone",
  "block.minecraft.infested_cobblestone": "infested cobble",
  "block.minecraft.infested_stone_bricks": "infested bricks",
  "block.minecraft.infested_mossy_stone_bricks": "infested moss'd bricks",
  "block.minecraft.infested_cracked_stone_bricks": "infested crack'd bricks",
  "block.minecraft.infested_chiseled_stone_bricks": "infested chisel'd stone bricks",
  "block.minecraft.stone_bricks": "stone bricks",
  "block.minecraft.mossy_stone_bricks": "moss'd stone bricks",
  "block.minecraft.cracked_stone_bricks": "crack'd stone bricks",
  "block.minecraft.chiseled_stone_bricks": "chisel'd stone bricks",
  "block.minecraft.brown_mushroom_block": "block of brown mushrooms",
  "block.minecraft.red_mushroom_block": "block of red mushrooms",
  "block.minecraft.mushroom_stem": "mushroom stem",
  "block.minecraft.iron_bars": "iron bars",
  "block.minecraft.chain": "chain",
  "block.minecraft.glass_pane": "glass pane",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "vines",
  "block.minecraft.oak_fence_gate": "oaken hedge gate",
  "block.minecraft.spruce_fence_gate": "pine hedge gate",
  "block.minecraft.birch_fence_gate": "birchen hedge gate",
  "block.minecraft.jungle_fence_gate": "exotic hedge gate",
  "block.minecraft.acacia_fence_gate": "beechen hedge gate",
  "block.minecraft.dark_oak_fence_gate": "ebony hedge gate",
  "block.minecraft.crimson_fence_gate": "crimsonwood hedge gate",
  "block.minecraft.warped_fence_gate": "warpwood hedge gate",
  "block.minecraft.brick_stairs": "brick stairs",
  "block.minecraft.stone_brick_stairs": "stone brick stairs",
  "block.minecraft.mycelium": "mouldy dirt",
  "block.minecraft.lily_pad": "water-lily",
  "block.minecraft.nether_bricks": "nether bricks",
  "block.minecraft.cracked_nether_bricks": "crack'd nether bricks",
  "block.minecraft.chiseled_nether_bricks": "chisel'd nether bricks",
  "block.minecraft.nether_brick_fence": "small nether brick hedge",
  "block.minecraft.nether_brick_stairs": "nether brick stairs",
  "block.minecraft.enchanting_table": "table of witchcrafts",
  "block.minecraft.end_portal_frame": "end portal frame",
  "block.minecraft.end_stone": "end stone",
  "block.minecraft.end_stone_bricks": "end stone bricks",
  "block.minecraft.dragon_egg": "dragon egg",
  "block.minecraft.redstone_lamp": "redstone lamp",
  "block.minecraft.sandstone_stairs": "sandstone stairs",
  "block.minecraft.emerald_ore": "emerald ore",
  "block.minecraft.ender_chest": "ender chest",
  "block.minecraft.tripwire_hook": "tripping hook",
  "block.minecraft.emerald_block": "block of emerald",
  "block.minecraft.spruce_stairs": "pine stairs",
  "block.minecraft.birch_stairs": "birchen stairs",
  "block.minecraft.jungle_stairs": "exotic stairs",
  "block.minecraft.crimson_stairs": "crimsonwood stairs",
  "block.minecraft.warped_stairs": "warpwood stairs",
  "block.minecraft.command_block": "command block",
  "block.minecraft.beacon": "beacon",
  "block.minecraft.cobblestone_wall": "cobble hedge",
  "block.minecraft.mossy_cobblestone_wall": "moss'd cobble hedge",
  "block.minecraft.brick_wall": "brick hedge",
  "block.minecraft.prismarine_wall": "prismarine hedge",
  "block.minecraft.red_sandstone_wall": "red sandstone hedge",
  "block.minecraft.mossy_stone_brick_wall": "moss'd stone brick hedge",
  "block.minecraft.granite_wall": "red grainstone hedge",
  "block.minecraft.stone_brick_wall": "stone brick hedge",
  "block.minecraft.nether_brick_wall": "nether brick hedge",
  "block.minecraft.andesite_wall": "grainstone hedge",
  "block.minecraft.red_nether_brick_wall": "red nether brick hedge",
  "block.minecraft.sandstone_wall": "sandstone hedge",
  "block.minecraft.end_stone_brick_wall": "end stone brick hedge",
  "block.minecraft.diorite_wall": "limestone hedge",
  "block.minecraft.blackstone_wall": "blackstone hedge",
  "block.minecraft.polished_blackstone_wall": "polish'd blackstone hedge",
  "block.minecraft.polished_blackstone_brick_wall": "polish'd blackstone brick hedge",
  "block.minecraft.stone_button": "stone button",
  "block.minecraft.oak_button": "oaken button",
  "block.minecraft.spruce_button": "pine button",
  "block.minecraft.birch_button": "birchen button",
  "block.minecraft.jungle_button": "exotic button",
  "block.minecraft.acacia_button": "beechen button",
  "block.minecraft.dark_oak_button": "ebon button",
  "block.minecraft.crimson_button": "crimsonwood button",
  "block.minecraft.warped_button": "warpwood button",
  "block.minecraft.polished_blackstone_button": "polish'd blackstone button",
  "block.minecraft.anvil": "anvil",
  "block.minecraft.chipped_anvil": "crack'd anvil",
  "block.minecraft.damaged_anvil": "fracted anvil",
  "block.minecraft.trapped_chest": "entrapped chest",
  "block.minecraft.light_weighted_pressure_plate": "light pressure plate",
  "block.minecraft.heavy_weighted_pressure_plate": "heavy pressure plate",
  "block.minecraft.daylight_detector": "sun watcher",
  "block.minecraft.redstone_block": "block of redstone",
  "block.minecraft.nether_quartz_ore": "nether quarz ore",
  "block.minecraft.hopper": "conveyer",
  "block.minecraft.chiseled_quartz_block": "chisel'd block of quarz",
  "block.minecraft.quartz_block": "block of quarz",
  "block.minecraft.quartz_bricks": "quarz bricks",
  "block.minecraft.quartz_pillar": "pillar of quarz",
  "block.minecraft.quartz_stairs": "quarz stairs",
  "block.minecraft.activator_rail": "sparking iron-rut",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "white earthen block",
  "block.minecraft.orange_terracotta": "tawny earthen block",
  "block.minecraft.magenta_terracotta": "mulberry earthen block",
  "block.minecraft.light_blue_terracotta": "whey earthen block",
  "block.minecraft.yellow_terracotta": "yellow earthen block",
  "block.minecraft.lime_terracotta": "lincoln earthen block",
  "block.minecraft.pink_terracotta": "carnation earthen block",
  "block.minecraft.gray_terracotta": "grey earthen block",
  "block.minecraft.light_gray_terracotta": "pale grey earthen block",
  "block.minecraft.cyan_terracotta": "turquoise earthen block",
  "block.minecraft.purple_terracotta": "purple earthen block",
  "block.minecraft.blue_terracotta": "blue earthen block",
  "block.minecraft.brown_terracotta": "brown earthen block",
  "block.minecraft.green_terracotta": "green earthen block",
  "block.minecraft.red_terracotta": "red earthen block",
  "block.minecraft.black_terracotta": "black earthen block",
  "block.minecraft.barrier": "closture",
  "block.minecraft.iron_trapdoor": "iron hatch",
  "block.minecraft.hay_block": "hay bundle",
  "block.minecraft.white_carpet": "white carpet",
  "block.minecraft.orange_carpet": "tawny carpet",
  "block.minecraft.magenta_carpet": "mulberry carpet",
  "block.minecraft.light_blue_carpet": "whey carpet",
  "block.minecraft.yellow_carpet": "yellow carpet",
  "block.minecraft.lime_carpet": "lincoln carpet",
  "block.minecraft.pink_carpet": "carnation carpet",
  "block.minecraft.gray_carpet": "grey carpet",
  "block.minecraft.light_gray_carpet": "pale grey carpet",
  "block.minecraft.cyan_carpet": "turquoise carpet",
  "block.minecraft.purple_carpet": "purple carpet",
  "block.minecraft.blue_carpet": "blue carpet",
  "block.minecraft.brown_carpet": "brown carpet",
  "block.minecraft.green_carpet": "green carpet",
  "block.minecraft.red_carpet": "red carpet",
  "block.minecraft.black_carpet": "black carpet",
  "block.minecraft.terracotta": "earthen block",
  "block.minecraft.coal_block": "block of coal",
  "block.minecraft.packed_ice": "press'd ice",
  "block.minecraft.acacia_stairs": "beechen stairs",
  "block.minecraft.dark_oak_stairs": "ebon stairs",
  "block.minecraft.slime_block": "block of slime",
  "block.minecraft.grass_path": "trodden path",
  "block.minecraft.sunflower": "heliotrope",
  "block.minecraft.lilac": "gillyvor",
  "block.minecraft.rose_bush": "rose bush",
  "block.minecraft.peony": "musk-rose",
  "block.minecraft.tall_grass": "tall grass",
  "block.minecraft.large_fern": "large fern",
  "block.minecraft.white_stained_glass": "white-coloured glass",
  "block.minecraft.orange_stained_glass": "tawny-coloured glass",
  "block.minecraft.magenta_stained_glass": "mulberry-coloured glass",
  "block.minecraft.light_blue_stained_glass": "whey-coloured glass",
  "block.minecraft.yellow_stained_glass": "yellow-coloured glass",
  "block.minecraft.lime_stained_glass": "lincoln-coloured glass",
  "block.minecraft.pink_stained_glass": "carnation-coloured glass",
  "block.minecraft.gray_stained_glass": "grey-coloured glass",
  "block.minecraft.light_gray_stained_glass": "pale grey-coloured glass",
  "block.minecraft.cyan_stained_glass": "turquoise-coloured glass",
  "block.minecraft.purple_stained_glass": "purple-coloured glass",
  "block.minecraft.blue_stained_glass": "blue-coloured glass",
  "block.minecraft.brown_stained_glass": "brown-coloured glass",
  "block.minecraft.green_stained_glass": "green-coloured glass",
  "block.minecraft.red_stained_glass": "red-coloured glass",
  "block.minecraft.black_stained_glass": "black-coloured glass",
  "block.minecraft.white_stained_glass_pane": "white-coloured glass pane",
  "block.minecraft.orange_stained_glass_pane": "tawny-coloured glass pane",
  "block.minecraft.magenta_stained_glass_pane": "mulberry-coloured glass pane",
  "block.minecraft.light_blue_stained_glass_pane": "whey-coloured glass pane",
  "block.minecraft.yellow_stained_glass_pane": "yellow-coloured glass pane",
  "block.minecraft.lime_stained_glass_pane": "lincoln-coloured glass pane",
  "block.minecraft.pink_stained_glass_pane": "carnation-coloured glass pane",
  "block.minecraft.gray_stained_glass_pane": "grey-coloured glass pane",
  "block.minecraft.light_gray_stained_glass_pane": "pale grey-coloured glass pane",
  "block.minecraft.cyan_stained_glass_pane": "turquoise-coloured glass pane",
  "block.minecraft.purple_stained_glass_pane": "purple-coloured glass pane",
  "block.minecraft.blue_stained_glass_pane": "blue-coloured glass pane",
  "block.minecraft.brown_stained_glass_pane": "brown-coloured glass pane",
  "block.minecraft.green_stained_glass_pane": "green-coloured glass pane",
  "block.minecraft.red_stained_glass_pane": "red-coloured glass pane",
  "block.minecraft.black_stained_glass_pane": "black-coloured glass pane",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine bricks",
  "block.minecraft.dark_prismarine": "dark prismarine",
  "block.minecraft.prismarine_stairs": "prismarine stairs",
  "block.minecraft.prismarine_brick_stairs": "prismarine brick stairs",
  "block.minecraft.dark_prismarine_stairs": "dark prismarine stairs",
  "block.minecraft.sea_lantern": "sea lantern",
  "block.minecraft.red_sandstone": "red sandstone",
  "block.minecraft.chiseled_red_sandstone": "chisel'd red sandstone",
  "block.minecraft.cut_red_sandstone": "cut red sandstone",
  "block.minecraft.red_sandstone_stairs": "red sandstone stairs",
  "block.minecraft.repeating_command_block": "repeating command block",
  "block.minecraft.chain_command_block": "chain command block",
  "block.minecraft.magma_block": "block of burning stone",
  "block.minecraft.nether_wart_block": "block of nether wart",
  "block.minecraft.warped_wart_block": "block of warp'd wart",
  "block.minecraft.red_nether_bricks": "red nether bricks",
  "block.minecraft.bone_block": "block of bones",
  "block.minecraft.structure_void": "structure void",
  "block.minecraft.observer": "watcher",
  "block.minecraft.shulker_box": "shulker case",
  "block.minecraft.white_shulker_box": "white shulker case",
  "block.minecraft.orange_shulker_box": "tawny shulker case",
  "block.minecraft.magenta_shulker_box": "mulberry shulker case",
  "block.minecraft.light_blue_shulker_box": "whey shulker case",
  "block.minecraft.yellow_shulker_box": "yellow shulker case",
  "block.minecraft.lime_shulker_box": "lincoln shulker case",
  "block.minecraft.pink_shulker_box": "carnation shulker case",
  "block.minecraft.gray_shulker_box": "grey shulker case",
  "block.minecraft.light_gray_shulker_box": "pale grey shulker case",
  "block.minecraft.cyan_shulker_box": "turquoise shulker case",
  "block.minecraft.purple_shulker_box": "purple shulker case",
  "block.minecraft.blue_shulker_box": "blue shulker case",
  "block.minecraft.brown_shulker_box": "brown shulker case",
  "block.minecraft.green_shulker_box": "green shulker case",
  "block.minecraft.red_shulker_box": "red shulker case",
  "block.minecraft.black_shulker_box": "black shulker case",
  "block.minecraft.white_glazed_terracotta": "white porcelain",
  "block.minecraft.orange_glazed_terracotta": "tawny porcelain",
  "block.minecraft.magenta_glazed_terracotta": "mulberry porcelain",
  "block.minecraft.light_blue_glazed_terracotta": "whey porcelain",
  "block.minecraft.yellow_glazed_terracotta": "yellow porcelain",
  "block.minecraft.lime_glazed_terracotta": "lincoln porcelain",
  "block.minecraft.pink_glazed_terracotta": "carnation porcelain",
  "block.minecraft.gray_glazed_terracotta": "grey porcelain",
  "block.minecraft.light_gray_glazed_terracotta": "pale grey porcelain",
  "block.minecraft.cyan_glazed_terracotta": "turquoise porcelain",
  "block.minecraft.purple_glazed_terracotta": "purple porcelain",
  "block.minecraft.blue_glazed_terracotta": "blue porcelain",
  "block.minecraft.brown_glazed_terracotta": "brown porcelain",
  "block.minecraft.green_glazed_terracotta": "green porcelain",
  "block.minecraft.red_glazed_terracotta": "red porcelain",
  "block.minecraft.black_glazed_terracotta": "black porcelain",
  "block.minecraft.white_concrete": "white cement",
  "block.minecraft.orange_concrete": "tawny cement",
  "block.minecraft.magenta_concrete": "mulberry cement",
  "block.minecraft.light_blue_concrete": "whey cement",
  "block.minecraft.yellow_concrete": "yellow cement",
  "block.minecraft.lime_concrete": "lincoln cement",
  "block.minecraft.pink_concrete": "carnelian cement",
  "block.minecraft.gray_concrete": "grey cement",
  "block.minecraft.light_gray_concrete": "pale grey cement",
  "block.minecraft.cyan_concrete": "turquoise cement",
  "block.minecraft.purple_concrete": "purple cement",
  "block.minecraft.blue_concrete": "blue cement",
  "block.minecraft.brown_concrete": "brown cement",
  "block.minecraft.green_concrete": "green cement",
  "block.minecraft.red_concrete": "red cement",
  "block.minecraft.black_concrete": "black cement",
  "block.minecraft.white_concrete_powder": "white cement powder",
  "block.minecraft.orange_concrete_powder": "tawny cement powder",
  "block.minecraft.magenta_concrete_powder": "mulberry cement powder",
  "block.minecraft.light_blue_concrete_powder": "whey cement powder",
  "block.minecraft.yellow_concrete_powder": "yellow cement powder",
  "block.minecraft.lime_concrete_powder": "lincoln cement powder",
  "block.minecraft.pink_concrete_powder": "carnelian cement powder",
  "block.minecraft.gray_concrete_powder": "grey cement powder",
  "block.minecraft.light_gray_concrete_powder": "pale grey cement powder",
  "block.minecraft.cyan_concrete_powder": "turquoise cement powder",
  "block.minecraft.purple_concrete_powder": "purple cement powder",
  "block.minecraft.blue_concrete_powder": "blue cement powder",
  "block.minecraft.brown_concrete_powder": "brown cement powder",
  "block.minecraft.green_concrete_powder": "green cement powder",
  "block.minecraft.red_concrete_powder": "red cement powder",
  "block.minecraft.black_concrete_powder": "black cement powder",
  "block.minecraft.turtle_egg": "turtle egg",
  "block.minecraft.dead_tube_coral_block": "block of dead blue coral",
  "block.minecraft.dead_brain_coral_block": "block of dead carnation coral",
  "block.minecraft.dead_bubble_coral_block": "block of dead purple coral",
  "block.minecraft.dead_fire_coral_block": "block of dead red coral",
  "block.minecraft.dead_horn_coral_block": "block of dead yellow coral",
  "block.minecraft.tube_coral_block": "block of blue coral",
  "block.minecraft.brain_coral_block": "block of carnation coral",
  "block.minecraft.bubble_coral_block": "block of purple coral",
  "block.minecraft.fire_coral_block": "red coral block",
  "block.minecraft.horn_coral_block": "yellow coral block",
  "block.minecraft.tube_coral": "blue coral",
  "block.minecraft.brain_coral": "carnation coral",
  "block.minecraft.bubble_coral": "purple coral",
  "block.minecraft.fire_coral": "red coral",
  "block.minecraft.horn_coral": "yellow coral",
  "block.minecraft.dead_brain_coral": "dead carnation coral",
  "block.minecraft.dead_bubble_coral": "dead purple coral",
  "block.minecraft.dead_fire_coral": "dead red coral",
  "block.minecraft.dead_horn_coral": "dead yellow coral",
  "block.minecraft.dead_tube_coral": "dead blue coral",
  "block.minecraft.tube_coral_fan": "small blue coral",
  "block.minecraft.brain_coral_fan": "small carnation coral",
  "block.minecraft.bubble_coral_fan": "small purple coral",
  "block.minecraft.fire_coral_fan": "small red coral",
  "block.minecraft.horn_coral_fan": "small yellow coral",
  "block.minecraft.dead_tube_coral_fan": "dead small blue coral",
  "block.minecraft.dead_brain_coral_fan": "dead small carnation coral",
  "block.minecraft.dead_bubble_coral_fan": "dead small purple coral",
  "block.minecraft.dead_fire_coral_fan": "dead small red coral",
  "block.minecraft.dead_horn_coral_fan": "dead small yellow coral",
  "block.minecraft.blue_ice": "blue ice",
  "block.minecraft.conduit": "conduit",
  "block.minecraft.polished_granite_stairs": "red grained marble stairs",
  "block.minecraft.smooth_red_sandstone_stairs": "smooth red sandstone stairs",
  "block.minecraft.mossy_stone_brick_stairs": "moss'd stone brick stairs",
  "block.minecraft.polished_diorite_stairs": "white marble stairs",
  "block.minecraft.mossy_cobblestone_stairs": "moss'd cobble stairs",
  "block.minecraft.end_stone_brick_stairs": "end stone brick stairs",
  "block.minecraft.stone_stairs": "stone stairs",
  "block.minecraft.smooth_sandstone_stairs": "smooth sandstone stairs",
  "block.minecraft.smooth_quartz_stairs": "smooth quarz stairs",
  "block.minecraft.granite_stairs": "red grainstone stairs",
  "block.minecraft.andesite_stairs": "grainstone stairs",
  "block.minecraft.red_nether_brick_stairs": "red nether brick stairs",
  "block.minecraft.polished_andesite_stairs": "grained marble stairs",
  "block.minecraft.diorite_stairs": "limestone stairs",
  "block.minecraft.polished_granite_slab": "red grained marble slab",
  "block.minecraft.smooth_red_sandstone_slab": "smooth red sandstone slab",
  "block.minecraft.mossy_stone_brick_slab": "moss'd stone brick slab",
  "block.minecraft.polished_diorite_slab": "white marble slab",
  "block.minecraft.mossy_cobblestone_slab": "moss'd cobble slab",
  "block.minecraft.end_stone_brick_slab": "end stone brick slab",
  "block.minecraft.smooth_sandstone_slab": "smooth sandstone slab",
  "block.minecraft.smooth_quartz_slab": "smooth quarz slab",
  "block.minecraft.granite_slab": "red grainstone slab",
  "block.minecraft.andesite_slab": "grainstone slab",
  "block.minecraft.red_nether_brick_slab": "red nether brick slab",
  "block.minecraft.polished_andesite_slab": "grained marble slab",
  "block.minecraft.diorite_slab": "limestone slab",
  "block.minecraft.scaffolding": "scaffolding",
  "block.minecraft.iron_door": "iron door",
  "block.minecraft.oak_door": "oaken door",
  "block.minecraft.spruce_door": "pine door",
  "block.minecraft.birch_door": "birchen door",
  "block.minecraft.jungle_door": "exotic door",
  "block.minecraft.acacia_door": "beechen door",
  "block.minecraft.dark_oak_door": "ebon door",
  "block.minecraft.crimson_door": "crimsonwood door",
  "block.minecraft.warped_door": "warpwood door",
  "block.minecraft.repeater": "redstone repeater",
  "block.minecraft.comparator": "redstone metre",
  "block.minecraft.structure_block": "structure block",
  "block.minecraft.jigsaw": "unfolding block",
  "item.minecraft.turtle_helmet": "turtle shell□□on the head:□+2 armour",
  "item.minecraft.scute": "scale",
  "item.minecraft.iron_shovel": "iron spade□□in the main hand:□+3.5 strike damage□-3 strike speed",
  "item.minecraft.iron_pickaxe": "iron pickaxe□□in the main hand:□+3 strike damage□-2.8 strike speed",
  "item.minecraft.iron_axe": "iron axe□□in the main hand:□+8 strike damage□-3.1 strike speed",
  "item.minecraft.flint_and_steel": "flint and steel",
  "item.minecraft.apple": "apple",
  "item.minecraft.bow": "bow",
  "item.minecraft.arrow": "arrow",
  "item.minecraft.coal": "coal",
  "item.minecraft.charcoal": "charcoal",
  "item.minecraft.diamond": "diamond",
  "item.minecraft.iron_ingot": "iron ingot",
  "item.minecraft.gold_ingot": "gold ingot",
  "item.minecraft.netherite_ingot": "netherite ingot",
  "item.minecraft.netherite_scrap": "scrap of netherite",
  "item.minecraft.iron_sword": "iron sword□□in the main hand:□+5 strike damage□-2.4 strike speed",
  "item.minecraft.wooden_sword": "wooden sword□□in the main hand:□+3 strike damage□-2.4 strike speed",
  "item.minecraft.wooden_shovel": "wooden spade□□in the main hand:□+1.5 strike damage□-3 strike speed",
  "item.minecraft.wooden_pickaxe": "wooden pickaxe□□in the main hand:□+1 strike damage□-2.8 strike speed",
  "item.minecraft.wooden_axe": "wooden axe□□in the main hand:□+6 strike damage□-3.2 strike speed",
  "item.minecraft.stone_sword": "stone sword□□in the main hand:□+4 strike damage□-2.4 strike speed",
  "item.minecraft.stone_shovel": "stone spade□□in the main hand:□+2.5 strike damage□-3 strike speed",
  "item.minecraft.stone_pickaxe": "stone pickaxe□□in the main hand:□+2 strike damage□-2.8 strike speed",
  "item.minecraft.stone_axe": "stone axe□□in the main hand:□+8 strike damage□-3.2 strike speed",
  "item.minecraft.diamond_sword": "diamond sword□□in the main hand:□+6 strike damage□-2.4 strike speed",
  "item.minecraft.diamond_shovel": "diamond spade□□in the main hand:□+4.5 strike damage□-3 strike speed",
  "item.minecraft.diamond_pickaxe": "diamond pickaxe□□in the main hand:□+4 strike damage□-2.8 strike speed",
  "item.minecraft.diamond_axe": "diamond axe□□in the main hand:□+8 strike damage□-3 strike speed",
  "item.minecraft.stick": "stick",
  "item.minecraft.bowl": "bowl",
  "item.minecraft.mushroom_stew": "mushroom stew",
  "item.minecraft.golden_sword": "golden sword□□in the main hand:□+3 strike damage□-2.4 strike speed",
  "item.minecraft.golden_shovel": "golden spade□□in the main hand:□+1.5 strike damage□-3 strike speed",
  "item.minecraft.golden_pickaxe": "golden pickaxe□□in the main hand:□+1 strike damage□-2.8 strike speed",
  "item.minecraft.golden_axe": "golden axe□□in the main hand:□+6 strike damage□-3 strike speed",
  "item.minecraft.netherite_sword": "netherite sword□□in the main hand:□+7 strike damage□-2.4 strike speed",
  "item.minecraft.netherite_shovel": "netherite shovel□□in the main hand:□+5.5 strike damage□-3 strike speed",
  "item.minecraft.netherite_pickaxe": "netherite pickaxe□□in the main hand:□+5 strike damage□-2.8 strike speed",
  "item.minecraft.netherite_axe": "netherite axe□□in the main hand:□+9 strike damage□-3 strike speed",
  "item.minecraft.string": "string",
  "item.minecraft.feather": "feather",
  "item.minecraft.gunpowder": "gunpowder",
  "item.minecraft.wooden_hoe": "wooden hoe□□in the main hand:□-3 strike speed",
  "item.minecraft.stone_hoe": "stone hoe□□in the main hand:□-2 strike speed",
  "item.minecraft.iron_hoe": "iron hoe□□in the main hand:□-1 strike speed",
  "item.minecraft.diamond_hoe": "diamond hoe□□in the main hand:",
  "item.minecraft.golden_hoe": "golden hoe□□in the main hand:□-3 strike speed",
  "item.minecraft.netherite_hoe": "netherite hoe□□in the main hand:",
  "item.minecraft.wheat_seeds": "wheat seeds",
  "item.minecraft.wheat": "wheat",
  "item.minecraft.bread": "bread",
  "item.minecraft.leather_helmet": "leathern coif□□on the head:□+1 armour",
  "item.minecraft.leather_chestplate": "leathern doublet□□on the torso:□+3 armour",
  "item.minecraft.leather_leggings": "leathern hose□□on the legs:□+2 armour",
  "item.minecraft.leather_boots": "leathern boots□□on the feet:□+1 armour",
  "item.minecraft.chainmail_helmet": "mailed coif□□on the head:□+2 armour",
  "item.minecraft.chainmail_chestplate": "mailed hauberk□□on the torso:□+5 armour",
  "item.minecraft.chainmail_leggings": "mailed hose□□on the legs:□+4 armour",
  "item.minecraft.chainmail_boots": "mailed sabatons□□on the feet:□+1 armour",
  "item.minecraft.iron_helmet": "iron casque□□on the head:□+2 armour",
  "item.minecraft.iron_chestplate": "iron breast plate□□on the torso:□+6 armour",
  "item.minecraft.iron_leggings": "iron greaves□□on the legs:□+5 armour",
  "item.minecraft.iron_boots": "iron sabatons□□on the feet:□+2 armour",
  "item.minecraft.diamond_helmet": "diamond casque□□on the head:□+3 armour□+2 armour toughness",
  "item.minecraft.diamond_chestplate": "diamond breast plate□□on the torso:□+8 armour□+2 armour toughness",
  "item.minecraft.diamond_leggings": "diamond greaves□□on the legs:□+6 armour□+2 armour toughness",
  "item.minecraft.diamond_boots": "diamond sabatons□□on the feet:□+3 armour□+2 armour toughness",
  "item.minecraft.golden_helmet": "golden casque□□on the head:□+2 armour",
  "item.minecraft.golden_chestplate": "golden breast plate□□on the torso:□+5 armour",
  "item.minecraft.golden_leggings": "golden greaves□□on the legs:□+3 armour",
  "item.minecraft.golden_boots": "golden sabatons□□on the feet:□+1 armour",
  "item.minecraft.netherite_helmet": "netherite helmet□□on the head:□+3 armour□+3 armour toughness□+1 forbearing resistance",
  "item.minecraft.netherite_chestplate": "netherite breastplate□□on the torso:□+8 armour□+3 armour toughness□+1 forbearing resistance",
  "item.minecraft.netherite_leggings": "netherite greaves□□on the legs:□+6 armour□+3 armour toughness□+1 forbearing resistance",
  "item.minecraft.netherite_boots": "netherite sabatons□□on the feet:□+3 armour□+3 armour toughness□+1 forbearing resistance",
  "item.minecraft.flint": "flint",
  "item.minecraft.porkchop": "raw bacon",
  "item.minecraft.cooked_porkchop": "roasted bacon",
  "item.minecraft.painting": "painting",
  "item.minecraft.golden_apple": "gilded apple",
  "item.minecraft.enchanted_golden_apple": "bewitch'd gilded apple",
  "block.minecraft.oak_sign": "oaken sign",
  "block.minecraft.spruce_sign": "pine sign",
  "block.minecraft.birch_sign": "birchen sign",
  "block.minecraft.jungle_sign": "exotic sign",
  "block.minecraft.acacia_sign": "beechen sign",
  "block.minecraft.dark_oak_sign": "ebon sign",
  "block.minecraft.crimson_sign": "crimsonwood sign",
  "block.minecraft.warped_sign": "warpwood sign",
  "item.minecraft.bucket": "bucket",
  "item.minecraft.water_bucket": "water'd bucket",
  "item.minecraft.lava_bucket": "bucket of molten stone",
  "item.minecraft.minecart": "iron cart",
  "item.minecraft.saddle": "saddle",
  "item.minecraft.redstone": "redstone dust",
  "item.minecraft.snowball": "snowball",
  "item.minecraft.oak_boat": "oaken boat",
  "item.minecraft.leather": "leather",
  "item.minecraft.milk_bucket": "bucket o' milk",
  "item.minecraft.pufferfish_bucket": "blowfish in a bucket",
  "item.minecraft.salmon_bucket": "salmon in a bucket",
  "item.minecraft.cod_bucket": "cod in a bucket",
  "item.minecraft.tropical_fish_bucket": "exotic fish in a bucket",
  "item.minecraft.brick": "brick",
  "item.minecraft.clay_ball": "ball of clay",
  "block.minecraft.dried_kelp_block": "block of dried seaweed",
  "item.minecraft.paper": "paper",
  "item.minecraft.book": "book",
  "item.minecraft.slime_ball": "slimeball",
  "item.minecraft.chest_minecart": "chest in a cart",
  "item.minecraft.furnace_minecart": "furnace in a cart",
  "item.minecraft.egg": "egg",
  "item.minecraft.compass": "compass",
  "item.minecraft.fishing_rod": "fishing rod",
  "item.minecraft.clock": "clock",
  "item.minecraft.glowstone_dust": "glowstone dust",
  "item.minecraft.cod": "raw cod",
  "item.minecraft.salmon": "raw salmon",
  "item.minecraft.tropical_fish": "exotic fish",
  "item.minecraft.pufferfish": "blowfish",
  "item.minecraft.cooked_cod": "cooked cod",
  "item.minecraft.cooked_salmon": "cooked salmon",
  "item.minecraft.ink_sac": "ink sack",
  "item.minecraft.red_dye": "red dye",
  "item.minecraft.green_dye": "green dye",
  "item.minecraft.cocoa_beans": "cocoa beans",
  "item.minecraft.lapis_lazuli": "lapis",
  "item.minecraft.purple_dye": "purple dye",
  "item.minecraft.cyan_dye": "turquoise dye",
  "item.minecraft.light_gray_dye": "pale grey dye",
  "item.minecraft.gray_dye": "grey dye",
  "item.minecraft.pink_dye": "carnation dye",
  "item.minecraft.lime_dye": "lincoln dye",
  "item.minecraft.yellow_dye": "yellow dye",
  "item.minecraft.light_blue_dye": "whey dye",
  "item.minecraft.magenta_dye": "mulberry dye",
  "item.minecraft.orange_dye": "tawny dye",
  "item.minecraft.bone_meal": "bone powder",
  "item.minecraft.blue_dye": "blue dye",
  "item.minecraft.brown_dye": "brown dye",
  "item.minecraft.black_dye": "black dye",
  "item.minecraft.white_dye": "white dye",
  "item.minecraft.bone": "bone",
  "item.minecraft.sugar": "sugar",
  "block.minecraft.cake": "cake",
  "block.minecraft.white_bed": "white bed",
  "block.minecraft.orange_bed": "tawny bed",
  "block.minecraft.magenta_bed": "mulberry bed",
  "block.minecraft.light_blue_bed": "whey bed",
  "block.minecraft.yellow_bed": "yellow bed",
  "block.minecraft.lime_bed": "lincoln bed",
  "block.minecraft.pink_bed": "carnation bed",
  "block.minecraft.gray_bed": "grey bed",
  "block.minecraft.light_gray_bed": "pale grey bed",
  "block.minecraft.cyan_bed": "turquoise bed",
  "block.minecraft.purple_bed": "purple bed",
  "block.minecraft.blue_bed": "blue bed",
  "block.minecraft.brown_bed": "brown bed",
  "block.minecraft.green_bed": "green bed",
  "block.minecraft.red_bed": "red bed",
  "block.minecraft.black_bed": "black bed",
  "item.minecraft.cookie": "biscuit",
  "item.minecraft.filled_map": "map□#0",
  "item.minecraft.shears": "shears",
  "item.minecraft.melon_slice": "melon piece",
  "item.minecraft.dried_kelp": "dried seaweed",
  "item.minecraft.pumpkin_seeds": "pumpion seeds",
  "item.minecraft.melon_seeds": "melon seeds",
  "item.minecraft.beef": "raw beef",
  "item.minecraft.cooked_beef": "roasted beef",
  "item.minecraft.chicken": "raw fowl",
  "item.minecraft.cooked_chicken": "roasted fowl",
  "item.minecraft.rotten_flesh": "rotten flesh",
  "item.minecraft.ender_pearl": "ender pearl",
  "item.minecraft.blaze_rod": "red-hot rod",
  "item.minecraft.ghast_tear": "ghast tear",
  "item.minecraft.gold_nugget": "gold lump",
  "item.minecraft.nether_wart": "nether wart",
  "item.minecraft.potion": "uncraftable potion□no effects",
  "item.minecraft.glass_bottle": "glass bottle",
  "item.minecraft.spider_eye": "spider eye",
  "item.minecraft.fermented_spider_eye": "fermented spider eye",
  "item.minecraft.blaze_powder": "brimstone powder",
  "item.minecraft.magma_cream": "brimstone cream",
  "block.minecraft.brewing_stand": "alchemy table",
  "block.minecraft.cauldron": "cauldron",
  "item.minecraft.ender_eye": "bewitch'd ender pearl",
  "item.minecraft.glistering_melon_slice": "gilded melon piece",
  "item.minecraft.bat_spawn_egg": "adder stone o' bat",
  "item.minecraft.bee_spawn_egg": "adder stone o' bee",
  "item.minecraft.blaze_spawn_egg": "adder stone of will o' the wisp",
  "item.minecraft.cat_spawn_egg": "adder stone o' cat",
  "item.minecraft.cave_spider_spawn_egg": "adder stone o' cave spider",
  "item.minecraft.chicken_spawn_egg": "adder stone o' fowl",
  "item.minecraft.cod_spawn_egg": "adder stone o' cod",
  "item.minecraft.cow_spawn_egg": "adder stone o' cow",
  "item.minecraft.creeper_spawn_egg": "adder stone o' creeper",
  "item.minecraft.dolphin_spawn_egg": "adder stone o' dolphin",
  "item.minecraft.donkey_spawn_egg": "adder stone o' ass",
  "item.minecraft.drowned_spawn_egg": "adder stone o' grindylow",
  "item.minecraft.elder_guardian_spawn_egg": "adder stone o' morgen sprite",
  "item.minecraft.enderman_spawn_egg": "adder stone o' enderman",
  "item.minecraft.endermite_spawn_egg": "adder stone o' endermite",
  "item.minecraft.evoker_spawn_egg": "adder stone o' sorcerer",
  "item.minecraft.fox_spawn_egg": "adder stone o' fox",
  "item.minecraft.ghast_spawn_egg": "adder stone o' ghast",
  "item.minecraft.guardian_spawn_egg": "adder stone o' water sprite",
  "item.minecraft.hoglin_spawn_egg": "adder stone o' hoglin",
  "item.minecraft.horse_spawn_egg": "adder stone o' horse",
  "item.minecraft.husk_spawn_egg": "adder stone o' fear gortach",
  "item.minecraft.llama_spawn_egg": "adder stone o' llama",
  "item.minecraft.magma_cube_spawn_egg": "adder stone o' burning cube",
  "item.minecraft.mooshroom_spawn_egg": "adder stone o' mooshroom",
  "item.minecraft.mule_spawn_egg": "adder stone o' mule",
  "item.minecraft.ocelot_spawn_egg": "adder stone o' wildcat",
  "item.minecraft.panda_spawn_egg": "adder stone o' parti-coloured bear",
  "item.minecraft.parrot_spawn_egg": "adder stone o' parrot",
  "item.minecraft.phantom_spawn_egg": "adder stone o' night hag",
  "item.minecraft.pig_spawn_egg": "adder stone o' pig",
  "item.minecraft.piglin_spawn_egg": "adder stone o' piglin",
  "item.minecraft.pillager_spawn_egg": "adder stone o' wild huntsman",
  "item.minecraft.polar_bear_spawn_egg": "adder stone o' bear",
  "item.minecraft.pufferfish_spawn_egg": "adder stone o' blowfish",
  "item.minecraft.rabbit_spawn_egg": "adder stone o' hare",
  "item.minecraft.ravager_spawn_egg": "adder stone o' wild hound",
  "item.minecraft.salmon_spawn_egg": "adder stone o' salmon",
  "item.minecraft.sheep_spawn_egg": "adder stone o' sheep",
  "item.minecraft.shulker_spawn_egg": "adder stone o' shulker",
  "item.minecraft.silverfish_spawn_egg": "adder stone o' atomy",
  "item.minecraft.skeleton_spawn_egg": "adder stone o' restless skeleton",
  "item.minecraft.skeleton_horse_spawn_egg": "adder stone o' ghostly horse",
  "item.minecraft.slime_spawn_egg": "adder stone o' slime cube",
  "item.minecraft.spider_spawn_egg": "adder stone o' spider",
  "item.minecraft.squid_spawn_egg": "adder stone o' cuttlefish",
  "item.minecraft.stray_spawn_egg": "adder stone o' mummy",
  "item.minecraft.strider_spawn_egg": "adder stone o' strider",
  "item.minecraft.trader_llama_spawn_egg": "adder stone o' pack llama",
  "item.minecraft.tropical_fish_spawn_egg": "adder stone o' exotic fish",
  "item.minecraft.turtle_spawn_egg": "adder stone o' turtle",
  "item.minecraft.vex_spawn_egg": "adder stone o' familiar",
  "item.minecraft.villager_spawn_egg": "adder stone o' peasant",
  "item.minecraft.vindicator_spawn_egg": "adder stone o' boggart",
  "item.minecraft.wandering_trader_spawn_egg": "adder stone o' wandering merchant",
  "item.minecraft.witch_spawn_egg": "adder stone o' witch",
  "item.minecraft.wither_skeleton_spawn_egg": "adder stone o' wither'd skeleton",
  "item.minecraft.wolf_spawn_egg": "adder stone o' wolf",
  "item.minecraft.zoglin_spawn_egg": "adder stone o' zoglin",
  "item.minecraft.zombie_spawn_egg": "adder stone o' undead wight",
  "item.minecraft.zombie_horse_spawn_egg": "adder stone o' undead horse",
  "item.minecraft.zombie_villager_spawn_egg": "adder stone o' cannibal peasant",
  "item.minecraft.zombified_piglin_spawn_egg": "adder stone o' rott'd piglin",
  "item.minecraft.experience_bottle": "bottle o' bewitchment",
  "item.minecraft.fire_charge": "blasting charge",
  "item.minecraft.writable_book": "book and quill",
  "item.minecraft.written_book": "writ book",
  "item.minecraft.emerald": "emerald",
  "item.minecraft.item_frame": "item frame",
  "block.minecraft.flower_pot": "flower pot",
  "item.minecraft.carrot": "caret",
  "item.minecraft.potato": "potato",
  "item.minecraft.baked_potato": "roasted potato",
  "item.minecraft.poisonous_potato": "green potato",
  "item.minecraft.map": "blank map",
  "item.minecraft.golden_carrot": "golden caret",
  "block.minecraft.skeleton_skull": "skull",
  "block.minecraft.wither_skeleton_skull": "wither'd skull",
  "block.minecraft.player_head": "player's head",
  "block.minecraft.zombie_head": "rotten head",
  "block.minecraft.creeper_head": "creeper head",
  "block.minecraft.dragon_head": "dragon head",
  "item.minecraft.carrot_on_a_stick": "caret o'stick",
  "item.minecraft.warped_fungus_on_a_stick": "warp'd mushrump on a stick",
  "item.minecraft.nether_star": "nether star",
  "item.minecraft.pumpkin_pie": "pumpion pie",
  "item.minecraft.firework_rocket": "firework",
  "item.minecraft.firework_star": "firework charge",
  "item.minecraft.enchanted_book": "enchanted book",
  "item.minecraft.nether_brick": "nether brick",
  "item.minecraft.quartz": "nether quarz",
  "item.minecraft.tnt_minecart": "gunpowder cask in a cart",
  "item.minecraft.hopper_minecart": "conveyer in a cart",
  "item.minecraft.prismarine_shard": "prismarine shard",
  "item.minecraft.prismarine_crystals": "prismarine crystals",
  "item.minecraft.rabbit": "raw hare",
  "item.minecraft.cooked_rabbit": "roasted hare",
  "item.minecraft.rabbit_stew": "hare stew",
  "item.minecraft.rabbit_foot": "hare's foot",
  "item.minecraft.rabbit_hide": "hare skin",
  "item.minecraft.armor_stand": "armour stand",
  "item.minecraft.iron_horse_armor": "iron horse barding",
  "item.minecraft.golden_horse_armor": "gilded horse barding",
  "item.minecraft.diamond_horse_armor": "horse barding of diamond",
  "item.minecraft.leather_horse_armor": "leathern horse barding",
  "item.minecraft.lead": "tether",
  "item.minecraft.name_tag": "name marker",
  "item.minecraft.command_block_minecart": "command block in a cart",
  "item.minecraft.mutton": "raw mutton",
  "item.minecraft.cooked_mutton": "roasted mutton",
  "block.minecraft.white_banner": "white banner",
  "block.minecraft.orange_banner": "tawny banner",
  "block.minecraft.magenta_banner": "mulberry banner",
  "block.minecraft.light_blue_banner": "whey banner",
  "block.minecraft.yellow_banner": "yellow banner",
  "block.minecraft.lime_banner": "lincoln banner",
  "block.minecraft.pink_banner": "carnation banner",
  "block.minecraft.gray_banner": "grey banner",
  "block.minecraft.light_gray_banner": "pale grey banner",
  "block.minecraft.cyan_banner": "turquoise banner",
  "block.minecraft.purple_banner": "purple banner",
  "block.minecraft.blue_banner": "blue banner",
  "block.minecraft.brown_banner": "brown banner",
  "block.minecraft.green_banner": "green banner",
  "block.minecraft.red_banner": "red banner",
  "block.minecraft.black_banner": "black banner",
  "item.minecraft.end_crystal": "end crystal",
  "item.minecraft.chorus_fruit": "chorus fruit",
  "item.minecraft.popped_chorus_fruit": "popp'd chorus fruit",
  "item.minecraft.beetroot": "beet",
  "item.minecraft.beetroot_seeds": "beet seeds",
  "item.minecraft.beetroot_soup": "beet soup",
  "item.minecraft.dragon_breath": "dragons breath",
  "item.minecraft.splash_potion": "uncraftable throwing potion□no effects",
  "item.minecraft.spectral_arrow": "ghostly arrow",
  "item.minecraft.tipped_arrow": "uncraftable steeped arrow□no effects",
  "item.minecraft.lingering_potion": "uncraftable lingering potion□no effects",
  "item.minecraft.shield": "shield",
  "item.minecraft.elytra": "wings",
  "item.minecraft.spruce_boat": "pine boat",
  "item.minecraft.birch_boat": "birchen boat",
  "item.minecraft.jungle_boat": "exotic boat",
  "item.minecraft.acacia_boat": "beechen boat",
  "item.minecraft.dark_oak_boat": "ebony boat",
  "item.minecraft.totem_of_undying": "periapt",
  "item.minecraft.shulker_shell": "shulker shell",
  "item.minecraft.iron_nugget": "iron lump",
  "item.minecraft.knowledge_book": "book o' knowledge",
  "item.minecraft.debug_stick": "stick o' remedy",
  "item.minecraft.music_disc_13": "music plate□c418 - 13",
  "item.minecraft.music_disc_cat": "music plate□c418 - cat",
  "item.minecraft.music_disc_blocks": "music plate□c418 - blocks",
  "item.minecraft.music_disc_chirp": "music plate□c418 - chirp",
  "item.minecraft.music_disc_far": "music plate□c418 - far",
  "item.minecraft.music_disc_mall": "music plate□c418 - mall",
  "item.minecraft.music_disc_mellohi": "music plate□c418 - mellohi",
  "item.minecraft.music_disc_stal": "music plate□c418 - stal",
  "item.minecraft.music_disc_strad": "music plate□c418 - strad",
  "item.minecraft.music_disc_ward": "music plate□c418 - ward",
  "item.minecraft.music_disc_11": "music plate□c418 - 11",
  "item.minecraft.music_disc_wait": "music plate□c418 - wait",
  "item.minecraft.music_disc_pigstep": "music plate□lena raine - pigstep",
  "item.minecraft.trident": "trident□□in the main hand:□+8 strike damage□-2.9 strike speed",
  "item.minecraft.phantom_membrane": "night hag's skin",
  "item.minecraft.nautilus_shell": "nautilus shell",
  "item.minecraft.heart_of_the_sea": "neptune's heart",
  "item.minecraft.crossbow": "cross-bow",
  "item.minecraft.suspicious_stew": "suspicious stew",
  "block.minecraft.loom": "loom",
  "item.minecraft.flower_banner_pattern": "flower banner pattern□flower charge",
  "item.minecraft.creeper_banner_pattern": "creeper banner pattern□creeper charge",
  "item.minecraft.skull_banner_pattern": "skull banner pattern□poor yorick's charge",
  "item.minecraft.mojang_banner_pattern": "mojang banner pattern□thing",
  "item.minecraft.globe_banner_pattern": "globe banner pattern□globe",
  "item.minecraft.piglin_banner_pattern": "creeper banner pattern□snout",
  "block.minecraft.composter": "composter",
  "block.minecraft.barrel": "barrel",
  "block.minecraft.smoker": "smoker",
  "block.minecraft.blast_furnace": "forge",
  "block.minecraft.cartography_table": "mappery table",
  "block.minecraft.fletching_table": "fletching table",
  "block.minecraft.grindstone": "grindstone",
  "block.minecraft.lectern": "lectern",
  "block.minecraft.smithing_table": "smiths table",
  "block.minecraft.stonecutter": "masons table",
  "block.minecraft.bell": "bell",
  "block.minecraft.lantern": "lantern",
  "block.minecraft.soul_lantern": "soule lantern",
  "item.minecraft.sweet_berries": "sweet berries",
  "block.minecraft.campfire": "camp fire",
  "block.minecraft.soul_campfire": "campfire of soules",
  "block.minecraft.shroomlight": "shroomlight",
  "item.minecraft.honeycomb": "honeycomb",
  "block.minecraft.bee_nest": "beehive",
  "block.minecraft.beehive": "beehive",
  "item.minecraft.honey_bottle": "honey bottle",
  "block.minecraft.honey_block": "honey block",
  "block.minecraft.honeycomb_block": "honeycomb block",
  "block.minecraft.lodestone": "lodestone",
  "block.minecraft.netherite_block": "block of netherite",
  "block.minecraft.ancient_debris": "olde debris",
  "block.minecraft.target": "target",
  "block.minecraft.crying_obsidian": "crying obsidian",
  "block.minecraft.blackstone": "blackstone",
  "block.minecraft.blackstone_slab": "blackstone slab",
  "block.minecraft.blackstone_stairs": "blackstone stairs",
  "block.minecraft.gilded_blackstone": "gilded blackstone",
  "block.minecraft.polished_blackstone": "polish'd blackstone",
  "block.minecraft.polished_blackstone_slab": "polish'd blackstone slab",
  "block.minecraft.polished_blackstone_stairs": "polish'd blackstone stairs",
  "block.minecraft.chiseled_polished_blackstone": "chisel'd polish'd blackstone",
  "block.minecraft.polished_blackstone_bricks": "polish'd blackstone bricks",
  "block.minecraft.polished_blackstone_brick_slab": "polish'd blackstone brick slab",
  "block.minecraft.polished_blackstone_brick_stairs": "polish'd blackstone brick stairs",
  "block.minecraft.cracked_polished_blackstone_bricks": "crack'd polish'd blackstone bricks",
  "block.minecraft.respawn_anchor": "respawn anchor",
}
export const enws = items; 
